import Brand from "./Brand";
import { RoomId, useTranslation } from "./Localization";

type RoomHeaderProps = {
  roomId: RoomId;
};

export default function RoomHeader({ roomId }: RoomHeaderProps) {
  const { room } = useTranslation();
  const translatedRoom = room(roomId);
  return (
    <header className="room-header">
      <Brand compact />
      <div>
        <strong>
          {translatedRoom?.number}. {translatedRoom?.name}
        </strong>
        <small>{translatedRoom?.location}</small>
      </div>
    </header>
  );
}
